import UserList from '@/components/User/UserList'
import UserForm from '@/components/User/UserForm'
import UserDetail from '@/components/User/UserDetail'
import UserAuthorization from '@/components/User/UserAuthorization'

let UserRouter = [{
  path: '/user',
  name: 'UserList',
  component: UserList,
  meta: {
    title: 'Utilisateurs',
    requiresAuth: true,
    authorizations: ['user_index', 'desktop_access']
  }
}, {
  path: '/user/new',
  name: 'UserNew',
  component: UserForm,
  meta: {
    title: 'Nouvel utilisateur',
    requiresAuth: true,
    authorizations: ['user_new', 'desktop_access']
  }
}, {
  path: '/user/:id/edit',
  name: 'UserEdit',
  component: UserForm,
  meta: {
    title: 'Modifier un utilisateur',
    requiresAuth: true,
    authorizations: ['user_edit', 'desktop_access']
  }
}, {
  path: '/user/:id',
  name: 'UserDetail',
  component: UserDetail,
  meta: {
    title: 'Fiche utilisateur',
    requiresAuth: true,
    authorizations: ['user_show', 'desktop_access']
  }
}, {
  path: '/user/:id/authorization',
  name: 'UserAuthorization',
  component: UserAuthorization,
  meta: {
    title: "Autorisations de l'utilisateur",
    requiresAuth: true,
    authorizations: ['user-rights_edit', 'desktop_access']
  }
}]

export default UserRouter



// WEBPACK FOOTER //
// ./src/components/User/router.js